import React, { FC, useEffect, useState } from "react";
import { Card, Upload, Button, Tooltip } from "antd";
import { EyeOutlined, UploadOutlined } from "@ant-design/icons";
import { RootState } from "../../../../store/store";
import { useSelector } from "react-redux";
import {
  ClaimExtraDocument,
  mapClaimExtraDocumentsToDisplayUrls,
} from "../../../modals/BillRequiredDocumentModal";

type DocumentUploadProps = {
  documentTypes: any[];
  documentUrls: any[];
  handleFileChange: any;
  handleOpen: any;
  portalSubmission: boolean;
  documentRequestResponseDocuments: any;
  isApproved: boolean;
  uploadFileList: any;
  isIntimated: any;
  isEchsScheme?: any;
  isEchsOPPreAuth?: any;
  billRequiredDocuments?: any[];
  claimExtraDocuments?: ClaimExtraDocument[];
  onOpenSupportingChecklist?: () => void;
};

const DocumentUpload: FC<DocumentUploadProps> = ({
  documentTypes,
  documentUrls,
  handleFileChange,
  handleOpen,
  portalSubmission,
  documentRequestResponseDocuments,
  isApproved,
  uploadFileList,
  isIntimated,
  isEchsScheme,
  isEchsOPPreAuth,
  billRequiredDocuments = [],
  claimExtraDocuments = [],
  onOpenSupportingChecklist,
}) => {
  const [updatedDocumentUrls, setUpdatedDocumentUrls] = useState<any>();
  const { auth, patients } = useSelector((state: RootState) => state);

  useEffect(() => {
    const uploadedDocumentUrls: any =
      documentUrls?.filter((document: any) =>
        documentRequestResponseDocuments["requestedDocuments"]?.some(
          (doc: any) => doc?.label === document?.documentLabelType,
        ),
      ) || [];

    const billRequiredDisplayUrls =
      mapClaimExtraDocumentsToDisplayUrls(claimExtraDocuments);
    const existingUrls = new Set(
      uploadedDocumentUrls.map((doc: any) => doc.documentUrl),
    );
    const mergedUploadedUrls = [
      ...uploadedDocumentUrls,
      ...billRequiredDisplayUrls.filter(
        (doc) => !existingUrls.has(doc.documentUrl),
      ),
    ];

    setUpdatedDocumentUrls(mergedUploadedUrls);
  }, [documentRequestResponseDocuments, documentUrls, claimExtraDocuments]);

  const groupByLabelType = (docs: any[]) => {
    return docs?.reduce((acc: any, doc: any) => {
      const label = doc.documentLabelType;
      if (!acc[label]) acc[label] = [];
      acc[label].push(doc);
      return acc;
    }, {});
  };

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          margin: "16px 0",
        }}
      >
        <div
          style={{
            textDecoration:
              patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
              "ECHS"
                ? "none"
                : "underline",
            fontSize: "16px",
            fontWeight: "bold",
          }}
        >
          {patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
          "ECHS" ? (
            <div style={{ color: "red", textDecoration: "none" }}>
              Please Upload Digitally Signed Documents
            </div>
          ) : (
            <div>Request Document Upload</div>
          )}
        </div>
        {billRequiredDocuments?.length > 0 ? (
          <Button
            type="primary"
            style={{
              backgroundColor: "rgb(0, 76, 143)",
              color: "#fff",
              boxShadow: "0px 2px 8px 0px #00000040",
            }}
            onClick={() => onOpenSupportingChecklist?.()}
          >
            Supporting Document Checklist
          </Button>
        ) : null}
      </div>

      {/* <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
                    // padding: "15px 55px",
                    gap: 20,
                  }}
                >
                  {documentTypes?.map((documentType: any) => (
                    <Upload
                      id={documentType.id}
                      beforeUpload={() => false}
                      maxCount={1}
                      onChange={
                        handleFileChange &&
                        handleFileChange(documentType?.labelId)
                      }
                      showUploadList={false}
                      // disabled={isReadOnly}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        style={{ marginLeft: "10px", width: "100%" }}
                        //   disabled={isReadOnly}
                      >
                        {documentType?.label}
                      </Button>
                    </Upload>
                  ))}
                </div> */}

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          //   opacity: !portalSubmission ? 1 : 0.5,
          //   pointerEvents: !portalSubmission ? 'auto' : 'none',
        }}
      >
        {documentRequestResponseDocuments?.["requestedDocuments"]?.length > 0 &&
          documentRequestResponseDocuments?.["requestedDocuments"]?.map(
            (docType: any) => {
              //documentTypes?.map((docType: any) => {
              const matchingDocuments = documentUrls?.filter(
                (doc) => doc.documentLabelType === docType.label,
              );

              if (matchingDocuments?.length > 0 && !docType?.multiple) {
                return null;
              }

              return (
                <div
                  key={docType.id}
                  style={{
                    border: "1px solid #eee",
                    padding: 10,
                    borderRadius: 8,
                    display: "flex",
                    alignItems: "center",
                    // gap: 8,
                  }}
                >
                  {/* <div style={{ marginBottom: 8, fontWeight: "bold" }}>
                  {docType.label}
                </div> */}

                  {matchingDocuments?.length > 0 && !docType?.multiple ? (
                    <p></p>
                  ) : (
                    <Upload
                      multiple={docType?.multiple}
                      {...(docType?.multiple
                        ? { fileList: uploadFileList }
                        : {})}
                      showUploadList={false}
                      beforeUpload={() => false}
                      onChange={
                        handleFileChange &&
                        handleFileChange(docType?.labelId, docType?.multiple)
                      }
                      disabled={portalSubmission}
                    >
                      <Button
                        icon={<UploadOutlined />}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          borderRadius: 0,
                          border: "none",
                          borderTopLeftRadius: "6px",
                          borderBottomLeftRadius: "6px",
                        }}
                        // disabled={(auth?.role?.role === "FO_STAFF" && isIntimated) || portalSubmission || isApproved}
                        // disabled={portalSubmission}
                        disabled={
                          (isEchsOPPreAuth &&
                            docType?.label?.toUpperCase() === "OTHERS") ||
                          (isEchsScheme &&
                            (docType.label === "HOSPITAL BILL" ||
                              docType.label === "BILL SUMMARY" || 
                              docType.label === "DISCHARGE SUMMARY" ||
                              docType?.label?.toUpperCase() ===
                                "DISCHARGE PHOTO" ||
                              docType?.label?.toUpperCase() === "AUDIT REPORT"))
                            ? true
                            : portalSubmission
                        }
                      ></Button>
                    </Upload>
                  )}
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <Button
                      style={{
                        borderRadius: 0,
                        border: "none",
                        paddingLeft: 4,
                        borderTopRightRadius: "6px",
                        borderBottomRightRadius: "6px",
                      }}
                      iconPosition={"end"}
                      // icon={
                      //   matchingDocuments?.length > 0 ? (
                      //     <EyeOutlined
                      //       style={{ marginLeft: "0.6rem" }}
                      //       onClick={() => {
                      //         handleOpen(
                      //           matchingDocuments?.[0]?.documentLabelType
                      //         );
                      //       }}
                      //     />
                      //   ) : (
                      //     <></>
                      //   )
                      // }
                    >
                      {/* {docType.label}{" "} */}
                      <Tooltip title={docType?.label}>
                        <span>
                          {docType?.label?.length > 25
                            ? docType.label.substring(0, 25) + "..."
                            : docType.label}
                        </span>
                      </Tooltip>

                      {docType?.required ||
                      (patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName?.toUpperCase() ===
                        "ECHS" &&
                        patients?.fetchBasicDetails?.visitInfoResponse?.visitType?.toUpperCase() ===
                          "OP" &&
                        (patients?.fetchBasicDetails?.patientResponse?.age <
                          70 || patients?.fetchBasicDetails?.referralInfoResponse?.echsReferralResponse
        ?.referralNo) && docType?.label?.toLowerCase()?.includes("referral letter")) ? (
                        <span style={{ color: "red" }}>*</span>
                      ) : (
                        <></>
                      )}
                    </Button>
                  </div>

                  {/* {matchingDocuments?.length > 0 && (
                  // <ul style={{ marginTop: 10, paddingLeft: 0 }}>
                  //   {matchingDocuments.map((doc, i) => (
                  //     <li
                  //       key={i}
                  //       style={{
                  //         listStyle: "none",
                  //         display: "flex",
                  //         justifyContent: "space-between",
                  //         alignItems: "center",
                  //         padding: "6px 0",
                  //         borderBottom: "1px solid #f0f0f0",
                  //       }}
                  //     >
                  //       <a
                  //         href={doc.documentUrl}
                  //         target="_blank"
                  //         rel="noreferrer"
                  //       >
                  //         {doc.documentName || `Document ${i + 1}`}
                  //       </a>
                  //       <Button
                  //         danger
                  //         type="link"
                  //         icon={<DeleteOutlined />}
                  //         onClick={() =>
                  //           handleDeleteList(doc.documentType, doc.documentUrl, i)
                  //         }
                  //       />
                  //     </li>
                  //   ))}
                  // </ul>
  
                  <EyeOutlined
                    style={{ marginLeft: "0.6rem" }}
                    onClick={() => {
                      handleOpen();
                    }}
                  />
                )} */}
                </div>
              );
            },
          )}
      </div>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(4, 1fr)",
          gap: 10,
          borderTop:
            updatedDocumentUrls?.length > 0 ? "1px solid gray" : "none",
        }}
      >
        {Object.entries(groupByLabelType(updatedDocumentUrls || []))?.map(
          ([labelType, docs]: [any, any]) =>
            docs.map((docType: any, idx: any) => (
              <div
                key={docType.id}
                style={{
                  border: "1px solid #eee",
                  padding: 10,
                  borderRadius: 8,
                  display: "flex",
                  alignItems: "center",

                  // gap: 8,
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <Button
                    style={{
                      borderRadius: "6px",
                      border: "none",
                      paddingLeft: 20,
                      // borderTopRightRadius: "6px",
                      // borderBottomRightRadius: "6px",
                      background: docType?.deficiencyCheckStatus
                        ? "rgb(0, 109, 119)"
                        : docType?.deficiencyCheckStatus === "false" ||
                            docType?.deficiencyCheckStatus === false
                          ? "#DD2025"
                          : "#fff",
                      color:
                        docType?.deficiencyCheckStatus ||
                        docType?.deficiencyCheckStatus === false
                          ? "white"
                          : "black",
                    }}
                    iconPosition={"end"}
                    icon={
                      <EyeOutlined
                        style={{ marginLeft: "0.6rem" }}
                        onClick={() => {
                          handleOpen(
                            docType?.documentLabelType,
                            docType?.documentUrl,
                          );
                        }}
                      />
                    }
                  >
                    {docType?.documentLabelType} {idx + 1}{" "}
                  </Button>
                </div>
              </div>
            )),
        )}
      </div>
    </div>
  );
};

export default DocumentUpload;
